import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
/** Preview only supplied text; never infer results or render partial HTML/Markdown. */
export function ContentPreview({ text, code = false }) {
    const lines = text.slice(0, 2400).split(/\r?\n/).slice(0, 6);
    return code ? _jsx("pre", { className: "agent-content-preview agent-code-preview", tabIndex: 0, children: lines.map((line, index) => _jsxs("span", { className: "agent-preview-line", children: [line || '\u00a0', '\n'] }, index)) })
        : _jsx("div", { className: "agent-content-preview agent-text-preview", children: lines.join('\n') });
}
//# sourceMappingURL=ContentPreview.js.map